import React, { useState } from 'react'
import { Icon } from 'meinian-package/src/component'
import { Dropdown } from 'meinian-package/src/baseComponent'
import Select from 'meinian-package/src/baseComponent/select'
import util from 'meinian-package/src/utils/util'
import classNames from 'classnames'
import { RANK_STATUS, QUERY_TYPE } from '../enum'
import styles from './index.module.less'

export const RANK_STATUSES = [{ label: '最近采集', value: RANK_STATUS.COLLECT }, { label: '最近更新', value: RANK_STATUS.UPDATED }, { label: '最近打开', value: RANK_STATUS.OPEN }, { label: '最新创建', value: RANK_STATUS.CREATED_LASTED }, { label: '最早创建', value: RANK_STATUS.CREATED_EARLIEST }]
const QUERY_TYPES = [{ label: '我拥有的', value: QUERY_TYPE.MY }, { label: '我协作的', value: QUERY_TYPE.COOP }, { label: '全部灵感集', value: QUERY_TYPE.ALL }]

export const RANK_DEFAULT_VALUE = {
  rankStatus: +localStorage.getItem('meinianHomeInsRankStatus') || RANK_STATUS.COLLECT,
  queryType: +localStorage.getItem('meinianHomeInsQueryType') || QUERY_TYPE.ALL,
  topFirstStatus: 1
}

export const DefaultRank = ({ value, onChange }) => {
  return <Select
    allowClear={false}
    data={RANK_STATUSES}
    value={value}
    onChange={(v) => {
      localStorage.setItem('meinianHomeInsRankStatus', v)
      onChange(v)
    }}
  />
}

export default (props) => {
  const { onChange, data } = props
  const [visible, setVisible] = useState(false)

  return <Dropdown
    trigger="click"
    overlayClassName=""
    overlay={<div className={styles.collLayerSelect}>
      <div className="group-title">排序</div>
      <div className="group-line" />
      <div className="group-list">
        {RANK_STATUSES.map(m => <div
          className={classNames('group-list-item', 'fill-white-bg', { active: data.rankStatus == m.value })}
          active={data.rankStatus == m.value}
          onClick={() => {
            localStorage.setItem('meinianHomeInsRankStatus', m.value)
            util.track('mn-header-link', {
              module1: '侧边栏',
              module2: '灵感集',
              module3: '排序',
              module4: m.label,
            })
            onChange({ rankStatus: m.value }, m)
          }}
        >
          <Icon
            type="m-xiaoyan"
            style={{
              fontSize: 16, marginRight: 8, opacity: data.rankStatus == m.value ? 1 : 0 }}
          />
          {m.label}
        </div>)}
      </div>
      <div className="group-title">范围</div>
      <div className="group-line" />
      <div className="group-list">
        {QUERY_TYPES.map(m => <div
          className={classNames('group-list-item', 'fill-white-bg', { active: data.queryType == m.value })}
          active={data.queryType == m.value}
          onClick={() => {
            localStorage.setItem('meinianHomeInsQueryType', m.value)
            util.track('mn-header-link', {
              module1: '侧边栏',
              module2: '灵感集',
              module3: '范围',
              module4: m.label,
            })
            onChange({ queryType: m.value }, m)
          }}
        > <Icon type="m-xiaoyan" style={{ fontSize: 16, marginRight: 12, opacity: data.queryType == m.value ? 1 : 0 }} />
          {m.label}
        </div>)}
      </div>
    </div>}
    visible={visible}
    onVisibleChange={vis => setVisible(vis)}
  >
    <div className={classNames(styles.collLayerLabelValue, 'fill-grey-bg')}>
      {RANK_STATUSES.find(m => m.value == data.rankStatus)?.label || '排序'}
      <Icon type="m-Vxing_xia" style={{ transform: visible ? 'rotate(180deg)' : undefined, transition: 'all 0.3s' }} />
    </div>
  </Dropdown>
}
